// extracted by mini-css-extract-plugin
export var backgroundImage = "Section-module--background-image--d3952";
export var container = "Section-module--container--3c12c";
export var hasBackgroundImage = "Section-module--has-background-image--1c4ac";
export var noPadding = "Section-module--no-padding--cbc0f";
export var noPaddingBottom = "Section-module--no-padding-bottom--d53d6";
export var section = "Section-module--section--b91fb";